// extracted by mini-css-extract-plugin
export default {"showcase-box":"main_showcase-box__g3Ola","input-container":"main_input-container__CtXJ2","inputs":"main_inputs__ppK23"};